<div class="content">
  <p class="message">
    This line is for a discontinued product line that has been replaced with the VerticalFloorA.
  </p>
  <p class="message">
    Please delete the discontinued products and replace with the new Vertical Floor A
  </p>
</div>
